import app from "@/common/plugins/vueInstance";

export const formatterType = (value: any, type: string, config = {}) => {
  if (type == "decimal") {
    if (value) {
      return value.toLocaleString("pt-BR", {
        style: "decimal",
        ...config,
      });
    }

    return 0;
  }

  if (type == "k") {
    if (value) {
      return Intl.NumberFormat("en-GB", {
        notation: "compact",
        compactDisplay: "short",
      }).format(value);
    }

    return 0;
  }

  if (type == "date") {
    let day = "";
    let month = "";

    if (value.getDate() < 10) {
      day = `0${value.getDate()}`;
    } else {
      day = value.getDate().toString();
    }

    if (value.getMonth() + 1 <= 9) {
      month = `0${value.getMonth() + 1}`;
    } else {
      month = (value.getMonth() + 1).toString();
    }

    return `${value.getFullYear()}-${month}-${day}`;
  }

  if (type == "monthYear") {
    return new Date(value)
      .toLocaleString("pt-BR", {
        month: "short",
        year: "numeric",
      })
      .replace(". de ", "/");
  }

  if (type == "currency") {
    if (value) {
      return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }

    return "R$ 0,00";
  }
};

const formatter = {
  install(app: any) {
    app.config.globalProperties.$formatter = formatterType;
    app.provide("$formatter", formatterType);
  },
};

app.use(formatter);
